module.exports = __webpack_public_path__ + "img/about/80243-023.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-023.png
// module id = 20
// module chunks = 0